import { Key, ReactNode } from 'react';
import { Root, ToggleButton } from './ToggleButtonGroupStyle';

export interface ToggleButtonGroupOption<T> {
  label: ReactNode;
  value: T;
}

interface ToggleButtonGroupProps<TValue> {
  options: ToggleButtonGroupOption<TValue>[];
  value: TValue;
  onValueChange: (newValue: TValue) => void;
  /** @default false */
  mobile?: boolean;
}

export function ToggleButtonGroup<TValue extends Key>(props: ToggleButtonGroupProps<TValue>) {
  const mobile = props.mobile ?? false;

  return (
    <Root>
      {props.options.map(({ label, value }) => (
        <ToggleButton
          key={value}
          data-selected={value === props.value ? 'true' : 'false'}
          onClick={() => {
            if (value === props.value) return;
            props.onValueChange(value);
          }}
          $mobile={mobile}
        >
          {label}
        </ToggleButton>
      ))}
    </Root>
  );
}
